<template>
  <b-container fluid>
    <page-title><h2><router-link :to="{ name: 'InvoicePaymentTypeList' }" class="nav-link">Typy płatności</router-link>/<span v-if="item && !loading">{{ item['name'] }}</span></h2>
			<div v-if="item && !loading" class="page-title__buttons">
				<router-link :to="{name: 'InvoicePaymentTypeUpdate', params: { id: item.id }}" title="Edytuj" class="btn btn-default"><span>Edytuj</span><svg-icon name="edit"/></router-link>
			</div>
		</page-title>

		<div class="col page-element">
			<alert-loading v-if="loading"></alert-loading>
			<div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

			<div v-if="item && !loading" class="row">
				<div class="col-md-6">
					<table class="table table-data">
						<tbody>
							<tr>
								<td>Nazwa</td>
								<td>{{ item['name'] }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
    </div>
  </b-container>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: mapGetters({
      error: 'invoicepaymenttype/show/error',
      loading: 'invoicepaymenttype/show/loading',
      item: 'invoicepaymenttype/show/item',
    }),
    created () {
      this.$store.dispatch('invoicepaymenttype/show/retrieve', decodeURIComponent(this.$route.params.id));
    },
    beforeDestroy() {
      this.$store.dispatch('invoicepaymenttype/show/reset');
    }
  }
</script>



// WEBPACK FOOTER //
// Show.vue?92392bd0